// extracted by mini-css-extract-plugin
export default {"special-text":"GloryTemplate_special-text__O59Oh"};